import { AppBar, Stack, Box, Tooltip, Autocomplete, CircularProgress, Toolbar, TextField, Modal, useTheme, Table, TableCell, TableBody, TableContainer, TableHead, TableRow, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Divider, CssBaseline, alpha, useMediaQuery, Typography, LinearProgress, } from "@mui/material";
import { useState, useEffect } from "react";
import React from "react";
import * as XLSX from 'xlsx';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';


import CustomTableContainer from "../../../Layout/CustomTableContainer";
import { tokens } from "../../../theme/theme";

import useUserPermissions from "../../../components/user-permission/UserPermission";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useWarehouseDataReport from "../../../hooks/warehouse/useWarehouseDataReport";
import CustomPagination from "../../../components/table/CustomPagination";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";

import TableFilterRow from "../../../components/table/TableFilterRow";
import ProductionReportTable from "./ProductionReportTable";


// ✅ COMPLETE SINGLE FILE - Copy & Paste Ready


const WarehouseMasterDataReport = ({ handleBackWinderMachineEntry, reelID }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('Production Master Report');
    const openFirst = Boolean(anchorElFirst);
    const [newLocation, setNewLocation] = useState(false);
    const [warehouseList, setWarehouseList] = useState(true);
    const [warehouseSlots, setWarehouseSlots] = useState(false);
    const [isDataLoad, setIsDataLoad] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);

    const FILTER_OPTIONS = [
        { label: "Order", value: "order data" },
        { label: "Deckle", value: "deckle data" },
        { label: "Jumbo Production", value: "parent roll data" },
        { label: "Rewinder", value: "child roll data" },
        { label: "Reel", value: "reel weighment data" },
        { label: "Cutter", value: "temp pallet data" },
        { label: "Ream", value: "ream data" },
        { label: "Bundle", value: "bundle data" },
        { label: "Ream Pallet", value: "ream pallet data" },
        { label: "FG", value: "fg data" }
        // ,
        // { label: "Despatch", value: "despatch data" }
    ];
    const [filterType, setFilterType] = React.useState(FILTER_OPTIONS[0]);

    // component body:
    const [fromDate, setFromDate] = useState(() =>
        new Date(new Date().getFullYear(), new Date().getMonth(), 1)
            .toISOString()
            .slice(0, 10)
    );
    const [toDate, setToDate] = useState(() =>
        new Date().toISOString().slice(0, 10)
    );

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);

    const [directStoreMode, setDirectStoreMode] = useState(false);
    const { warehouseDataReportList, setWarehouseDataReportList, loadWarehouseByID, loading, setLoading, RefreshData, FilterProductionData } = useWarehouseDataReport();

    const [partyList, setPartyList] = useState([]);

    const [open, setOpen] = useState(false);
    const userPermissions = useUserPermissions();

    // skeleton progress 
    // const [loading, setLoading] = useState(false);
    const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'Production Master Report') {
            setSelectedStatus('All');
        }
        else if (option === 'Active Warehouse') {
            setSelectedStatus(true);
        }
        else if (option === 'Inactive Warehouse') {
            setSelectedStatus(false);
        }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        //handleMenuCloseSecond();
        if (option === 'Export Report') {
            handleExportToExcel(filteredData);
        }
        else if (option === 'Export Current View') {
            // handleExportToExcelCurrentView();
            handleExportToExcel(currentRecords);
        }
        else if (option === 'Refresh List') {
            RefreshData();
        }
    };

    const handleShowNewVendor = () => {
        setEditPartyID(0);
        setWarehouseList(false);
        setWarehouseSlots(false);
        setNewLocation(true);
        setSelectedWarehouse(null);
    }

    const handlecallback = () => {
        setEditPartyID(0);
        setWarehouseList(true);
        setWarehouseSlots(false);
        setNewLocation(false);
        loadWarehouseByID(0);
    }


    useEffect(() => {
        // alert('selected reel id :' + reelID);
        setDirectStoreMode(true);
    }, [reelID]);


    // Responsive breakpoints
    const isXs = useMediaQuery((theme) => theme.breakpoints.only("xs"));
    const isSm = useMediaQuery((theme) => theme.breakpoints.only("sm"));
    const isMd = useMediaQuery((theme) => theme.breakpoints.only("md"));
    const isLg = useMediaQuery((theme) => theme.breakpoints.only("lg"));
    const isXl = useMediaQuery((theme) => theme.breakpoints.only("xl"));


    // Update recordsPerPage based on screen size
    useEffect(() => {
        if (isXs) setRecordsPerPage(15);
        else if (isSm) setRecordsPerPage(10);
        else if (isMd) setRecordsPerPage(10);
        else if (isLg) setRecordsPerPage(15);
        else if (isXl) setRecordsPerPage(22);
    }, [isXs, isSm, isMd, isLg, isXl]);



    const [filters, setFilters] = useState({
        code: '',
        description: '',
        warehouse_type: '',
        environment_type: '',
        default_bin_type: '',
        wip_flag: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = partyList.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };

    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        } else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }
    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;


    const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('All');

    const filteredData = warehouseDataReportList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const [editPartyID, setEditPartyID] = useState(0)

    const [selectedwarehosue, setSelectedWarehouse] = useState({})
    const handleCallEdit = (row) => {
        setSelectedWarehouse(row);
        setWarehouseList(false);
        setNewLocation(true);
    };


    const pageCount = Math.ceil(warehouseDataReportList.length / recordsPerPage);

    // Get the records for the current page
    const currentRecords = filteredData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };


    // ✅ PERFECT MUI TABLE COLORS + EXACT 94 COLUMNS
    const excelColumns = [
        // 🟦 BLUE ACCENT 400 - Basic Info (0-21)
        { header: "INDENT MONTH", key: "indent_month" },
        { header: "REGION", key: "region" },
        { header: "DEALER", key: "dealer" },
        { header: "CONSIGNEE", key: "consignee" },
        { header: "DELIVERY NAME", key: "deliveryaddress" },
        { header: "DESTINATION", key: "destination" },
        { header: "ORDER STATUS", key: "orderstatus" },
        { header: "ORDER BLOCK", key: "-" },
        { header: "QUALITY", key: "quality" },
        { header: "GSM", key: "gsm" },
        { header: "WIDTH", key: "width" },
        { header: "LENGTH", key: "length" },
        { header: "PACKING MODE", key: "packing_mode" },
        { header: "SO DATE", key: "so_date" },
        { header: "REQUIR DELIVERY DATE", key: "requir_delivery_date" },
        { header: "SAP PO DATE", key: "" },
        { header: "SAP PO NO", key: "sap_po_no" },
        { header: "SAP PO ITEM LINE", key: "sap_po_item_line" },
        { header: "SO NO", key: "so_no" },
        { header: "ITEM LINE", key: "item_line" },
        { header: "PARTY PO NO", key: "po_no" },
        { header: "PARTY PO DATE", key: "po_date" },

        // 🔴 RED ACCENT 400 - Order Qty (22-23)
        { header: "SO NUMBER", key: "so_number" },
        { header: "ORDER QTY", key: "order_qty" },

        // 🔵 BLUE ACCENT 200 - Deckling (24-28)
        { header: "NO OF DECKLE PLAN", key: "number_of_mo" },
        { header: "DECKLE QTY", key: "deckle_qty" },
        { header: "DECKLE FIRST DATE", key: "deckle_first_date" },
        { header: "DECKLE LAST DATE", key: "deckle_last_date" },

        // 🔴 RED ACCENT 400 - Pending (29)
        { header: "MACHINE PENDING ORDER", key: "machine_pending_order" },

        // 🟠 ORANGE ACCENT 200 - Jumbo (30-34)
        { header: "NO OF PARENT ROLL", key: "number_of_parent_roll" },
        { header: "MA BOOKED QTY", key: "ma_booked_quantity" },
        { header: "M/C FIRST DATE", key: "machine_childroll_first_date" },
        { header: "M/C LAST DATE", key: "machine_childroll_last_date" },
        { header: "WIP RW QTY", key: "wip_rw_qty" },

        // 🟢 GREEN ACCENT 400 - Rewinder (35-46)
        { header: "TOTAL RW QTY", key: "total_rw_qty" },
        { header: "TOTAL RW REELS", key: "total_rw_reels" },
        { header: "RW QTY G1", key: "rw_qty_g1" },
        { header: "NO OF REELS G1", key: "no_of_reels_g1" },
        { header: "RW QTY S1", key: "rw_qty_s1" },
        { header: "NO OF REELS S1", key: "no_of_reels_s1" },
        { header: "RW QTY BUFFER", key: "rw_qty_buffer" },
        { header: "NO OF REELS BUFFER", key: "no_of_reels_buffer" },
        { header: "RW QTY REPULP", key: "rw_qty_repulp" },
        { header: "NO OF REELS REPULP", key: "no_of_reels_repulp" },
        { header: "RW QTY UNAPPROVED ", key: "rw_qty_un_approved" },
        { header: "NO OF REELS UNAPPROVED", key: "no_of_reels_un_approved" },
        { header: "RW FIRST DATE", key: "rw_first_date" },
        { header: "RW LAST DATE", key: "rw_last_date" },

        // 🟠 ORANGE ACCENT 400 - Reel (47-58)
        { header: "REEL WEIGHMENT QTY", key: "reel_weighment_qty" },
        { header: "REEL WEIGHMENT REELS", key: "reel_weighment_reels" },
        { header: "REEL ORDER QTY G1", key: "reel_order_qty_g1" },
        { header: "NO OF REELS", key: "no_of_reels" },
        { header: "REEL QTY S1", key: "reel_qty_s1" },
        { header: "REELS SL", key: "reels_sl" },
        { header: "REEL ORDER QTY REPULP", key: "reel_order_qty_repulp" },
        { header: "REELS REPULP", key: "reels_repulp" },
        { header: "REEL PROD FIRST DATE", key: "reel_prod_first_date" },
        { header: "REEL PROD LAST DATE", key: "reel_prod_last_date" },
        { header: "WIP REEL QTY", key: "wip_reel_qty" },
        { header: "WIP RW REELS", key: "wip_rw_reels" },

        // 🟣 PURPLE ACCENT 400 - Sheeter (59-70)
        { header: "SHEET QTY", key: "sheet_quantity" },
        { header: "NO OF REELS SHEET", key: "no_of_reels_sheet" },
        { header: "SHEET G1 WEIGHT", key: "sheet_g1_weight" },
        { header: "SHEET G1 REELS", key: "sheet_g1_reels" },
        { header: "SHEET SL WEIGHT", key: "sheet_sl_weight" },
        { header: "SHEET SL REELS", key: "sheet_sl_reels" },
        { header: "SHEET REPULP WEIGHT", key: "sheet_repulp_weight" },
        { header: "SHEET REPULP REELS", key: "sheet_repulp_reels" },
        { header: "SHEETING FIRST DATE", key: "sheeting_first_date" },
        { header: "SHEETING LAST DATE", key: "sheeting_last_date" },
        { header: "WIP SHEET QTY", key: "wip_sheet_quantity" },
        { header: "WIP SHEET REELS", key: "wip_sheet_reels" },

        // 🟡 YELLOW ACCENT 400 - Ream (71-82)
        { header: "REAM QTY", key: "ream_qty" },
        { header: "NO OF REAM", key: "no_of_ream" },
        { header: "REAM QTY G1", key: "ream_qty_g1" },
        { header: "REAMS G1", key: "reams_g1" },
        { header: "REAM QTY SL", key: "ream_qty_sl" },
        { header: "REAMS SL", key: "reams_sl" },
        { header: "REAM QTY REPULP", key: "ream_qty_repulp" },
        { header: "REAMS REPULP", key: "reams_repulp" },
        { header: "REAM PROD FIRST DATE", key: "ream_prod_first_date" },
        { header: "REAM PROD LAST DATE", key: "ream_prod_last_date" },
        { header: "WIP PALLET QTY", key: "wip_ream_quantity" },
        { header: "NO OF PALLET", key: "wip_pallet_count_val" },

        // 🟠 ORANGE ACCENT 400 - Bundle (83-94)
        { header: "BUNDLE QTY", key: "bundle_qty" },
        { header: "NO OF BUNDLE", key: "no_of_bundle" },
        { header: "BUNDLE G1 WEIGHT", key: "bundle_g1_weight" },
        { header: "BUNDLES G1", key: "bundles_g1" },
        { header: "BUNDLE QTY SL", key: "bundle_quantity_sl" },
        { header: "BUNDLES SL", key: "bundles_sl" },
        { header: "REPULP", key: "repulp" },
        { header: "BUNDLES REPULP", key: "bundles_repulp" },
        { header: "BUNDLE PROD FIRST DATE", key: "bundle_prod_first_date" },
        { header: "BUNDLE PROD LAST DATE", key: "bundle_prod_last_date" },
        { header: "WIP REAM QTY", key: "wip_bundle_quantity" },
        { header: "WIP NO OF REAMS", key: "wip_ream_count_val" },

        // REAM PALLET
        { header: "REAM PALLET QTY", key: "ream_pallet_qty" },
        { header: "NO OF REAM PALLET", key: "no_of_ream_pallet" },
        { header: "REAM PALLET G1 WEIGHT", key: "ream_pallet_g1_weight" },
        { header: "REAM PALLET G1", key: "ream_pallet_g1" },
        { header: "REAM PALLET QTY SL", key: "ream_pallet_quantity_sl" },
        { header: "REAM PALLET SL", key: "ream_pallet_sl" },
        { header: "REAM PALLET REPULP WEIGHT", key: "ream_pallet_repulp_qty" },
        { header: "REAM PALLET REPULP", key: "ream_pallet_repulp" },
        { header: "REAM PALLET PROD FIRST DATE", key: "ream_pallet_prod_first_date" },
        { header: "REAM PALLET PROD LAST DATE", key: "ream_pallet_prod_last_date" },
        // { header: "WIP REAM QTY", key: "wip_bundle_quantity" },
        // { header: "WIP NO OF REAMS", key: "wip_ream_count_val" },        

        // FG RECEVING
        { header: "LODGE TOTAL QTY", key: "lodge_quantity" },
        { header: "LODGE (G1) QTY", key: "lodge_g1_quantity" },
        { header: "LODGE (SL) QTY", key: "lodge_sl_quantity" },
        { header: "LODGE (REPULP) QTY", key: "lodge_repulp_quantity" },
        { header: "LODGEING FIRST DATE", key: "lodging_first_date" },
        { header: "LODGEING LAST DATE", key: "lodging_last_date" },
        { header: "WIP LODGE QTY", key: "wip_lodge_quantity" },
        { header: "REPULP", key: "lodge_repulp_qty" },
        { header: "SHORT FALL %", key: "-" },

        // INVOICE
        { header: "SAP FG QTY", key: "sap_fg_qty" },
        { header: "SAP FG  FIRST DATE", key: "sap_fg_first_date" },
        { header: "SAP FG LAST DATE", key: "sap_fg_last_date" },
        { header: "DISPATCH QTY", key: "despatch_qty" },
        { header: "DISPATCH FIRST DATE", key: "despatch_first_date" },
        { header: "DISPATCH LAST DATE", key: "despatch_last_date" },
        { header: "OA BALANCE", key: "overall_balance_qty" },
    ];

    // 🎨 EXACT MUI COLOR MAPPING
    const sectionColors = {
        // Blue sections
        0: '2196F3',  // blueAccent400 - Basic Info
        24: '90CAF9', // blueAccent200 - Deckling
        // Red sections  
        22: 'EF5350', // redAccent400 - Order/pending
        29: 'EF5350', // redAccent400 - Pending
        // Orange sections
        30: 'FFCC80', // orangeAccent200 - Jumbo
        47: 'FF9800', // orangeAccent400 - Reel/Bundle
        83: 'FF9800', // orangeAccent400 - Bundle
        // Green sections
        35: '66BB6A',  // greenAccent400 - Rewinder
        // Purple sections
        59: 'CE93D8',  // purpleAccent400 - Sheeter
        // Yellow sections
        71: 'FFEE58'   // yellowAccent400 - Ream
    };

    const handleExportToExcel = (currentRecords) => {
        try {
            const headers = excelColumns.map(col => col.header);

            // Identify columns to exclude from number formatting (text/date columns)
            const excludeFromNumberFormat = new Set([
                'INDENT MONTH', 'REGION', 'DEALER', 'CONSIGNEE', 'DELIVERY NAME', 'DESTINATION',
                'ORDER STATUS', 'QUALITY', 'GSM', 'WIDTH', 'LENGTH', 'PACKING MODE',
                'SAP PO NO', 'SAP PO ITEM LINE', 'SO NO', 'ITEM LINE', 'PARTY PO NO', 'SO NUMBER',
                'ORDER BLOCK', 'SHORT FALL %', 'REPULP',
                // All date columns
                'SO DATE', 'REQUIR DELIVERY DATE', 'SAP PO DATE', 'DECKLE FIRST DATE', 'DECKLE LAST DATE',
                'M/C FIRST DATE', 'M/C LAST DATE', 'RW FIRST DATE', 'RW LAST DATE',
                'REEL PROD FIRST DATE', 'REEL PROD LAST DATE',
                'SHEETING FIRST DATE', 'SHEETING LAST DATE',
                'REAM PROD FIRST DATE', 'REAM PROD LAST DATE',
                'BUNDLE PROD FIRST DATE', 'BUNDLE PROD LAST DATE',
                'REAM PALLET PROD FIRST DATE', 'REAM PALLET PROD LAST DATE',
                'LODGEING FIRST DATE', 'LODGEING LAST DATE',
                'SAP FG FIRST DATE', 'SAP FG LAST DATE', 'SAP FG  FIRST DATE',
                'DISPATCH FIRST DATE', 'DISPATCH LAST DATE',
                'PARTY PO DATE'
            ]);

            const numericColumnIndices = [];
            headers.forEach((header, idx) => {
                if (!excludeFromNumberFormat.has(header) && header !== '' && header !== '-') {
                    numericColumnIndices.push(idx);
                }
            });

            const data = [headers, ...currentRecords.map(row =>
                excelColumns.map((col, colIdx) => {
                    const value = row[col.key] ?? '-';
                    // Convert to number if it's a numeric column
                    if (numericColumnIndices.includes(colIdx) && value !== '-' && value !== '') {
                        return Number(value) || value;
                    }
                    return value;
                })
            )];

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.aoa_to_sheet(data);

            // Format numeric columns
            numericColumnIndices.forEach(colIdx => {
                const colLetter = XLSX.utils.encode_col(colIdx);
                for (let rowIdx = 0; rowIdx < currentRecords.length; rowIdx++) {
                    const cellRef = `${colLetter}${rowIdx + 2}`;
                    if (ws[cellRef] !== undefined && typeof ws[cellRef].v === 'number') {
                        ws[cellRef] = {
                            v: ws[cellRef].v,
                            t: 'n',
                            z: '0.00'
                        };
                    }
                }
            });

            // 🎨 APPLY EXACT MUI COLORS TO HEADERS
            headers.forEach((header, colIndex) => {
                let color = '000000'; // Default

                // Find matching section color
                Object.entries(sectionColors).forEach(([startCol, colorHex]) => {
                    if (colIndex >= parseInt(startCol) && colIndex < parseInt(startCol) + 12) {
                        color = colorHex;
                    }
                });

                // Style header cell
                const headerCell = XLSX.utils.encode_cell({ r: 0, c: colIndex });
                ws[headerCell].s = {
                    font: { bold: true, color: { rgb: "FFFFFF" } },
                    fill: {
                        patternType: 'solid',
                        fgColor: { rgb: color }
                    },
                    alignment: {
                        horizontal: "center",
                        vertical: "center",
                        wrapText: true
                    }
                };
            });

            // 🧊 Freeze header row
            ws['!rows'] = [{ hpx: 30 }];
            ws['!freeze'] = { x: 0, y: 1 };

            // 📏 Auto-fit columns
            const colWidths = headers.map(h => Math.max(h.length, 12));
            data.slice(1).forEach(row => {
                row.forEach((cell, i) => {
                    colWidths[i] = Math.max(colWidths[i], String(cell || '').length);
                });
            });
            ws['!cols'] = colWidths.map(w => ({ wch: Math.min(w + 2, 35) }));

            XLSX.utils.book_append_sheet(wb, ws, 'PRODUCTION MASTER');
            XLSX.writeFile(wb, 'Papyrus360_Production_Report.xlsx');

            console.log('✅ FULL COLOR EXPORT COMPLETE! 🎨');
        } catch (error) {
            console.error('❌ Export failed:', error);
        }
    };

    const columns = ['indent_month', 'region', 'dealer', 'consignee', 'deliveryaddress', 'destination', 'orderstatus', '', 'quality', 'gsm', 'width', 'length', 'packing_mode', 'so_date', 'requir_delivery_date', '', 'sap_po_no', 'sap_po_item_line', 'so_no', 'item_line', 'po_no', 'po_date', 'so_number', 'order_qty', 'number_of_mo', 'deckle_qty', 'deckle_first_date', 'deckle_last_date', 'machine_pending_order', 'number_of_parent_roll', 'ma_booked_quantity', 'machine_childroll_first_date', 'machine_childroll_last_date', 'wip_rw_qty', '', 'total_rw_qty', 'total_rw_reels', 'rw_qty_g1', 'no_of_reels_g1', 'rw_qty_s1', 'no_of_reels_s1', 'rw_qty_buffer', 'no_of_reels_buffer', 'rw_qty_repulp', 'no_of_reels_repulp', 'rw_qty_un_approved', 'no_of_reels_un_approved', 'rw_first_date', 'rw_last_date', 'reel_weighment_qty', 'reel_weighment_reels', 'reel_order_qty_g1', 'no_of_reels', 'reel_qty_s1', 'reels_sl', 'reel_order_qty_repulp', 'reels_repulp', 'reel_prod_first_date', 'reel_prod_last_date', 'wip_reel_qty', 'wip_rw_reels', 'sheet_quantity', 'no_of_reels_sheet', 'sheet_g1_weight', 'sheet_g1_reels', 'sheet_sl_weight', 'sheet_sl_reels', 'sheet_repulp_weight', 'sheet_repulp_reels', 'sheeting_first_date', 'sheeting_last_date', 'wip_sheet_quantity', 'wip_sheet_reels', 'ream_qty', 'no_of_ream', 'ream_qty_g1', 'reams_g1', 'ream_qty_sl', 'reams_sl', 'ream_qty_repulp', 'reams_repulp', 'ream_prod_first_date', 'ream_prod_last_date', 'wip_ream_quantity', 'wip_pallet_count_val', 'bundle_qty', 'no_of_bundle', 'bundle_g1_weight', 'bundles_g1', 'bundle_quantity_sl', 'bundles_sl', 'repulp', 'bundles_repulp', 'bundle_prod_first_date', 'bundle_prod_last_date', 'wip_bundle_quantity', 'wip_ream_count_val', 'ream_pallet_qty', 'no_of_ream_pallet', 'ream_pallet_g1_weight', 'ream_pallet_g1', 'ream_pallet_quantity_sl', 'ream_pallet_sl', 'ream_pallet_repulp_qty', 'ream_pallet_repulp', 'ream_pallet_prod_first_date', 'ream_pallet_prod_last_date', 'lodge_quantity', 'lodge_g1_quantity', 'lodge_sl_quantity', 'lodge_repulp_quantity', 'lodging_first_date', 'lodging_last_date', 'wip_lodge_quantity', 'lodge_repulp_qty', '', 'sap_fg_qty', 'sap_fg_first_date', 'sap_fg_last_date', 'despatch_qty', 'despatch_first_date', 'despatch_last_date', 'overall_balance_qty'];
    const autoCompleteColumns = ['deliveryaddress', 'orderstatus', 'indent_month', 'so_number', 'so_no', 'item_line', 'sap_po_no', 'sap_po_item_line', 'l_order_punch_date', 'so_date', 'requir_delivery_date', 'po_date', 'dealer', 'consignee', 'quality', 'gsm', 'width', 'length', 'packing_mode', 'order_qty', 'number_of_mo', 'deckle_qty', 'deckle_first_date', 'deckle_last_date', 'machine_pending_order', 'number_of_parent_roll', 'ma_booked_quantity', 'machine_childroll_first_date', 'machine_childroll_last_date', 'wip_rw_qty', 'rw_qty_g1', 'no_of_reels_g1', 'rw_qty_s1', 'no_of_reels_s1', 'rw_qty_buffer', 'no_of_reels_buffer', 'rw_qty_repulp', 'no_of_reels_repulp', 'rw_first_date', 'rw_last_date', 'reel_order_qty_g1', 'no_of_reels', 'reel_prod_first_date', 'reel_prod_last_date', 'reel_qty_s1', 'wip_reel_qty', 'sheet_quantity', 'no_of_reels_sheet', 'sheeting_first_date', 'sheeting_last_date', '	wip_sheet_quantity', 'ream_qty', 'no_of_ream', 'ream_prod_first_date', 'ream_prod_last_date', 'wip_ream_quantity', 'bundle_qty', 'no_of_bundle', 'bundle_prod_first_date', 'bundle_prod_last_date', 'bundle_quantity_sl', 'wip_bundle_quantity', 'repulp', 'lodge_quantity', 'lodging_first_date', 'lodging_last_date', 'wip_lodge_quantity'];

    const handleFilterChangeTable = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    // 'region', 
    const uniqueValues = {

        orderstatus: [...new Set(warehouseDataReportList.map(row => row.orderstatus))],
        so_no: [...new Set(warehouseDataReportList.map(row => row.so_no))],
        po_no: [...new Set(warehouseDataReportList.map(row => row.po_no))],
        so_number: [...new Set(warehouseDataReportList.map(row => row.so_number))],
        so_date: [...new Set(warehouseDataReportList.map(row => row.so_date))],
        requir_delivery_date: [...new Set(warehouseDataReportList.map(row => row.requir_delivery_date))],
        dealer: [...new Set(warehouseDataReportList.map(row => row.dealer))],
        consignee: [...new Set(warehouseDataReportList.map(row => row.consignee))],
        quality: [...new Set(warehouseDataReportList.map(row => row.quality))],
        gsm: [...new Set(warehouseDataReportList.map(row => row.gsm))],
        width: [...new Set(warehouseDataReportList.map(row => row.width))],
        length: [...new Set(warehouseDataReportList.map(row => row.length))],
        packing_mode: [...new Set(warehouseDataReportList.map(row => row.packing_mode))],
        deckle_first_date: [...new Set(warehouseDataReportList.map(row => row.deckle_first_date))],
        deckle_last_date: [...new Set(warehouseDataReportList.map(row => row.deckle_last_date))],
        machine_childroll_first_date: [...new Set(warehouseDataReportList.map(row => row.machine_childroll_first_date))],
        machine_childroll_last_date: [...new Set(warehouseDataReportList.map(row => row.machine_childroll_last_date))],
        reel_prod_first_date: [...new Set(warehouseDataReportList.map(row => row.reel_prod_first_date))],
        reel_prod_last_date: [...new Set(warehouseDataReportList.map(row => row.reel_prod_last_date))],
        sheeting_first_date: [...new Set(warehouseDataReportList.map(row => row.sheeting_first_date))],
        sheeting_last_date: [...new Set(warehouseDataReportList.map(row => row.sheeting_last_date))],
        ream_prod_first_date: [...new Set(warehouseDataReportList.map(row => row.ream_prod_first_date))],
        ream_prod_last_date: [...new Set(warehouseDataReportList.map(row => row.ream_prod_last_date))],
        bundle_prod_first_date: [...new Set(warehouseDataReportList.map(row => row.bundle_prod_first_date))],
        bundle_prod_last_date: [...new Set(warehouseDataReportList.map(row => row.bundle_prod_last_date))],
        lodging_first_date: [...new Set(warehouseDataReportList.map(row => row.lodging_first_date))],
        lodging_last_date: [...new Set(warehouseDataReportList.map(row => row.lodging_last_date))],

    };

    // filter data 

    const FilterDataByDateRange = async () => {
        let company = localStorage.getItem("companyid");
        await FilterProductionData(company, 1, filterType.value, fromDate, toDate);
    }

    return (
        <Box>
            <CssBaseline />
            {warehouseList && (<>
                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        <Button
                            color="secondary"
                            onClick={handleMenuClickFirst}
                            endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                            sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                        >
                            {selectedOptionFirst}
                        </Button>
                        <Menu
                            anchorEl={anchorElFirst}
                            open={openFirst}
                            onClose={handleMenuCloseFirst}

                        >
                            <MenuItem onClick={() => handleMenuItemClickFirst('Production Master Report')}>Production Master Report</MenuItem>

                        </Menu>

                        {/* Adding margin-left: auto to push the button to the right */}
                        {/* {hasPermission(userPermissions, "Warehouse master", "Create") && ( */}
                        {/* <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button> */}

                        {/* )} */}

                        {/* Second Menu */}
                        <IconButton
                            size="small"
                            // edge="start"
                            // color="inherit"
                            aria-label="menu"
                            sx={{ marginLeft: 'auto' }}
                            onClick={handleMenuClickSecond}
                        >
                            <MoreVertIcon sx={{ fontSize: "18px" }} />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElSecond}
                            open={openSecond}
                            onClose={handleMenuCloseSecond}
                        >
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Report')}>
                                <ListItemIcon>
                                    <FileDownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Report" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                <ListItemIcon>
                                    <ViewColumnIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Current View" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Preference " />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                <ListItemIcon>
                                    <RefreshIcon />
                                </ListItemIcon>
                                <ListItemText primary="Refresh List" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                    Reset Columns Width
                                </Button>
                            </MenuItem>
                        </Menu>

                        <IconButton
                            size="small"
                            aria-label="menu"
                            sx={{ mr: 1, ml: 1 }}
                            onClick={handleMenuClickSecond}
                        >
                            <HelpIcon sx={{ fontSize: "18px" }} />
                        </IconButton>

                        <div>
                            <IconButton onClick={handleBackWinderMachineEntry} >
                                <Close fontSize="inherit" style={{ fontSize: "18px", color: "#2196F3" }} />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>


                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2, mt: 2, ml: 2 }}>

                    <Stack direction="row" spacing={2} alignItems="center">

                        {/* Filter Type */}
                        <Autocomplete
                            size="small"
                            options={FILTER_OPTIONS}
                            value={filterType}
                            onChange={(event, newValue) => setFilterType(newValue)}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            sx={{ minWidth: 220 }}
                            renderInput={(params) => (
                                <TextField {...params} label="Filter Type" />
                            )}
                        />

                        <TextField
                            type="date"
                            size="small"
                            label="From"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            type="date"
                            size="small"
                            label="To"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                        <Button
                            variant="outlined"
                            size="small"
                            color="secondary"
                            onClick={() => FilterDataByDateRange()} // trigger refetch with new range
                        >
                            Apply
                        </Button>
                    </Stack>
                    <Stack direction="row" spacing={1}>

                    </Stack>
                </Box>
                <Divider />

                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        {loading ? (
                            
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    p: 3,
                                    textAlign: "center",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    color="text.secondary"
                                    sx={{ mb: 2, fontWeight: 500 }}
                                >
                                    ⏳ Loading large dataset... please wait, this may take a few minutes.
                                </Typography>

                                {/* Skeleton Table Loader */}
                                <SkeletonTableLoader rows={10} columns={6} />
                                <LinearProgress sx={{ width: "80%", mt: 2, borderRadius: 1 }} color="secondary" />

                            </Box>
                        ) : (
                            <ProductionReportTable columns={columns} filters={filters} handleFilterChangeTable={handleFilterChangeTable} uniqueValues={uniqueValues} autoCompleteColumns={autoCompleteColumns} currentRecords={currentRecords} />
                        )}
                    </TableContainer>
                </CustomTableContainer>
                <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />
            </>)}


        </Box>
    );
};
export default WarehouseMasterDataReport;



